<template>
    <div class="modal-roomlist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">房间类型修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="房间类型名称" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入房间类型名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="几人间" required prop="num">
                                    <el-col :span="24">
                                        <el-input-number v-model="editForm.num" :min='1'></el-input-number>
                                    </el-col>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="价格" required prop="price">元/{{chargeTime}}
                                    <el-input type="number" v-model="editForm.price" placeholder="请输入价格"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="房间状态" required prop="status">
                                    <el-select v-model="editForm.status" placeholder="选择房间状态" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getChargeTime} from "@/utils/auth";

    export default {
        name: 'Edit',
        props: ["buildingCodeValue"],
        data() {
            return {
                loading: false,
                chargeTime:'',
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    num:'',
                    status:'',
                    roomTypeCode:'',
                    price:''
                },
                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                floorValue:[],
                rules:{
                    floor:[
                        { required: true, message: '请输入楼层', trigger: 'blur' },
                    ],
                    number:[
                        { required: true, message: '请输入楼名称', trigger: 'blur' },
                    ],
                    buildingCode:[
                        { required: true, message: '请选择楼宇', trigger: 'blur' },
                    ],
                    roomType:[
                        { required: true, message: '请选择房间类型', trigger: 'blur' },
                        { type: 'number', message: '房间类型必须为数字值'}
                    ],
                    price:[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位", trigger: 'blur'
                        }
                    ],
                }

            }
        },

        methods: {

            init(row){
                console.log(row);
                this.editForm.name = row.name;
                this.editForm.num = row.num;
                this.editForm.roomTypeCode = row.roomTypeCode;
                this.editForm.status = row.status;
                if(getChargeTime()=='天'){
                    this.editForm.price = row.price;
                }else{
                    this.editForm.price = row.priceMonth;
                }
                this.chargeTime = getChargeTime();
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RoomType/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

        }
    }


</script>





<style lang="scss" scoped>

    .modal-roomlist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
        
        .modal {
            
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
